module.exports = __webpack_public_path__ + "static/media/sound_icon_white.de91e65c.svg";